<template>
  <div class="animated fadeIn">
    <basic-heading title="Time Series Report" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config">
          <template #post_buttons>
            <b-button variant="success" class="ml-1" :disabled="!report_data" @click="download">
              <i class="fal fa-download" />
            </b-button>
          </template>
        </header-button-group>
      </template>
    </basic-heading>

    <permission-alert-gate :permissions="'read customer'">
      <template #gated-content>

        <div v-if="report_data && report_data.data" ref="report" class="p-3">
          <TimeSeriesReport :report="report_data.data" :chart_type="chart_type" />
        </div>
        <TimeSeriesReportForm
          v-else
          @submit="submit"
          @setChartType="(chartType) => {
            chart_type = chartType
          }"
        />

      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import BasicHeading from '@/components/shared/BasicHeading'
import HeaderButtonGroup from '@/components/shared/headerbuttons/HeaderButtonGroup'
import PermissionAlertGate from '@/components/permission/PermissionAlertGate'
import TimeSeriesReportForm from '@/components/result/sampleresult/report/TimeSeriesReportForm.vue'
import { ResultRepositoryFactory } from '@/repositories/result/ResultRepositoryFactory'
import TimeSeriesReport from '@/components/result/sampleresult/report/TimeSeriesReport.vue'
import { downloadHtmlCanvas } from '@/shared/utils'

const SampleResultRepository = ResultRepositoryFactory.get('sampleResult')

export default {
  name: "CustomerTimeSeriesReport",
  components: {
    BasicHeading,
    HeaderButtonGroup,
    PermissionAlertGate,
    TimeSeriesReportForm,
    TimeSeriesReport
  },
  data () {
    return {
      report_data: null,
      customer_id: this.$route.params.customer_id || null,
      chart_type: 'bar',
    }
  },
  computed: {
    button_config () {
      return {
        buttons: [
        ],
      }
    },
  },
  methods: {
    async submit (form_data) {
      try {
        const { data } = await SampleResultRepository.getTimeSeriesReport({
          ...form_data,
          customer_id: this.customer_id,
        })
        this.report_data = data
      } catch ({ response }) {
        const { status, data } = response.response

        this.$bvToast.toast(data.message, {
          title: 'Error',
          variant: 'danger',
        })
      }
    },

    download() {
      const { report } = this.$refs;
      const fileName = `time-series-report.pdf`;
      downloadHtmlCanvas(report, fileName);
    }
  }
}
</script>
